module.exports = "https://coursera_assets.s3.amazonaws.com/images/e6636c6b8d2d141cbee6bf14f4b3d185.png";